module.exports = __webpack_public_path__ + "21ce49b58cef446b9474c13227ae10a1.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-1024.webp
// module id = 333
// module chunks = 0